import React from 'react';
import useStyles from './Styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import {Tools} from './Tools';
import {Inc,Owner} from './Inc';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

interface Props {
    list: any[],
    owner: Owner,
    pager: any,
    jump(newPage:number):void,
    selectedTypeId: string,
}

const FavListType = (props:Props)=> {
    const classes = useStyles();
	
	return (
		<div id="fav_list_search">

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.tableHeadNowrap} align='center'>スキの種類</TableCell>
                        <TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
            {props.list.map( (sale:any,index:number)=>{
                const key = "sale"+index;
                return (
                    <TableRow key={key}>
                        <TableCell className={classes.tableCellNowrap} style={{verticalAlign:"middle"}} align='center'>
                            {(sale.fav_type_id==="6") &&
                                <span className={classes.favIcon+" "+classes.favBackColor6}>
                                    <FontAwesomeIcon icon="gift"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"6")}</span>
                                </span>
                            }
                            {(sale.fav_type_id==="1") &&
                                <span className={classes.favIcon+" "+classes.favBackColor1}>
                                    <FontAwesomeIcon icon="heart"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"1")}</span>
                                </span>
                            }
                            {(sale.fav_type_id==="2") &&
                                <span className={classes.favIcon+" "+classes.favBackColor2}>
                                    <FontAwesomeIcon icon="redo"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"2")}</span>
                                </span>
                            }
                            {(sale.fav_type_id==="3") &&
                                <span className={classes.favIcon+" "+classes.favBackColor3}>
                                    <FontAwesomeIcon icon="lightbulb"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"3")}</span>
                                </span>
                            }
                            {(sale.fav_type_id==="4") &&
                                <span className={classes.favIcon+" "+classes.favBackColor4}>
                                    <FontAwesomeIcon icon="seedling"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"4")}</span>
                                </span>
                            }
                            {(sale.fav_type_id==="5") &&
                                <span className={classes.favIcon+" "+classes.favBackColor5}>
                                    <FontAwesomeIcon icon="gem"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"5")}</span>
                                </span>
                            }
                            {(sale.fav_type_id==="9") &&
                                <span className={classes.favIcon+" "+classes.favBackColor9}>
                                    <FontAwesomeIcon icon="comment"/>
                                    <span style={{marginLeft:"0.5em"}}>{Tools.getLabel(Inc.favTypes,"9")}</span>
                                </span>
                            }
                        </TableCell>
                        <TableCell>
                            {sale.list.map( (item:any,index2:number)=>{
                                const key = "item"+index2;
								let add;
                                if( sale.fav_type_id==="1" ){
                                    add = classes.favColor1;
                                } else if( sale.fav_type_id==="2" ){
                                    add = classes.favColor2;
                                } else if( sale.fav_type_id==="3" ){
                                    add = classes.favColor3;
                                } else if( sale.fav_type_id==="4" ){
                                    add = classes.favColor4;
                                } else if( sale.fav_type_id==="5" ){
                                    add = classes.favColor5;
                                } else if( sale.fav_type_id==="6" ){
                                    add = classes.favColor6;
                                } else if( sale.fav_type_id==="9" ){
                                    add = classes.favColor9;
                                }
                                const classname1 = classes.favTypeListCountMiddle+" "+add;
								const classname2 = classes.favTypeListCountTop+" "+add;
                                return (
                                    <div className={classes.favTypeList} key={key}>
                                        <div style={{marginBottom:'0.5em'}}><span className={classes.itemId}>ID:{item.item_id}</span></div>
                                        {item.item_name}
										<Hidden smDown implementation="js">
                                        <span className={classname1}>{Tools.comma(item.ct)}件</span>
										</Hidden>
										<Hidden smUp implementation="js">
										<span className={classname2}>{Tools.comma(item.ct)}件</span>
										</Hidden>
                                    </div>
                                )
                            })}
                        </TableCell>
                    </TableRow>
                );
            })}
                </TableBody>
            </Table>
            <div style={{padding:"1em"}}>
            {Tools.pager(props.pager,props.jump)}
            </div>


		</div>
	);
}

export default FavListType;
